import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Dialog, Button, Text } from "ui-components";

import {
  CompletionDialogWrapper,
  CompletionDialogHeader,
  CompletionDialogContent,
  CompletionDialogLinks,
  CompletionDialogLink,
  CompletionDialogText,
  CompletionDialogButtons
} from "./styled";

class CompletionDialog extends Component {
  /**
 * Render the Appendix PDF links
 * @param  {array} links List of PDF links and urls
 * @return {array}       Rendered Appendix PDF links
 */
  renderLinks = links => {
    // Only render if defined
    if (!links) {
      return null;
    }

    return (
      <CompletionDialogLinks>
        <Text size="3" weight="500" marginV="3">
          Consider including the following PDFs with this assessment:
        </Text>
        {links.map((link, idx) => {
          const pdfLink = require(`@public/assets/pdfs/${link.fileName}`);

          return (
            <Text key={`pdf_${idx}`}>
              <CompletionDialogLink href={pdfLink} target="_blank">
                {link.text}
              </CompletionDialogLink>
            </Text>
          );
        })}
      </CompletionDialogLinks>
    );
  };

  /**
   * Return to dashboard (location change will reset apps)
   */
  _onNewClick = () => {
    this.props.history.push("/");
  };

  render() {
    const { isShown, title, pdfLinks, onPdfClick } = this.props;
    const dialogSizes = {
      tabletMax: "576px",
      desktopMax: "576px",
      largeMax: "576px"
    };

    // Only render if shown
    if (!isShown) {
      return null;
    }

    return (
      <Dialog display={isShown} sizes={dialogSizes}>
        <CompletionDialogWrapper>
          <CompletionDialogHeader>
            {title}
          </CompletionDialogHeader>
          <CompletionDialogContent>
            <CompletionDialogText marginT="2">
              This Assessment is marked as complete.<br />
              Would you like to print it now?
            </CompletionDialogText>
            <CompletionDialogButtons>
              <Button
                key="new"
                secondary
                medium
                onClick={() => this._onNewClick()}
              >
                New Assessment
              </Button>
              <Button key="print" medium onClick={() => onPdfClick("print")}>
                Print
              </Button>
              <Button key="dwnld" medium onClick={() => onPdfClick("download")}>
                Download PDF
              </Button>
            </CompletionDialogButtons>
            {this.renderLinks(pdfLinks)}
          </CompletionDialogContent>
        </CompletionDialogWrapper>
      </Dialog>
    );
  }
}

export default withRouter(CompletionDialog);



// WEBPACK FOOTER //
// ./src/common/components/CompletionDialog/CompletionDialog.jsx